window.addEventListener('DOMContentLoaded', function() {

  $('.kids-site-header .grown-ups').clone().appendTo( $('#door-menu > div') );

  $('.kids-site-header .btn-dance-3x').clone().addClass('btn-desktop').prependTo( $('#door-menu > div') );
  $('.kids-site-header .btn-dance-3x').clone().addClass('btn-mobile').appendTo( $('#door-menu > div') );

  $(document).on('click','.anchor',function(){
    $('body').toggleClass('door-active');
    // console.log('anchor clicked');
  })

  $('.close-door').on('click',function(){
    $('body').toggleClass('door-active');
    return false;
  });

  $('.toggle-door').on('click',function(){
    $('body').toggleClass('door-active');
    $('html, body').animate({
      scrollTop: 0
    },200);
    return false;
  });

  $('.menu-overlay').on('click',function(){
    $('body').removeClass('door-active');
    return false;
  });

/**************************************************************************************/
/********* MAIN SLIDER
/**************************************************************************************/
if( $('.kids-main-slider').length ){
  let kids_main_slider = $('.kids-main-slider');
  let autoRotate = kids_main_slider.data('autorotate');
  let slideSpeed = kids_main_slider.data('speed');

  kids_main_slider.on('init', function(slick){
    $('.sec-slideshow').addClass('loaded');
  });

  kids_main_slider.slick({
    fade: true,
    infinite: false,
    adaptiveHeight: false,
    slidesToShow: 1,
    arrows: true,
    dots: true,
    prevArrow: '<span class="kids-arrow-prev"></span>',
    nextArrow: '<span class="kids-arrow-next"></span>',
    lazyLoad: 'progressive',
    autoplay: autoRotate,
    autoplaySpeed: slideSpeed,
    responsive: [
      {
        breakpoint: 1100,
        settings: {
          adaptiveHeight: true,
        }
      }
    ]
  });

  kids_main_slider.on('afterChange', function(slick, currentSlide){
    $('.sec-slideshow').attr('data-currentslide', currentSlide.currentSlide );
  });
}


/**************************************************************************************/
/********* PLAY SLIDER
/**************************************************************************************/
const kids_play_slider = $('.kids-play-slider');
let   play_page = 1;

function pull_play(current_page){
  $.ajax({url: '/blogs/play?view=play-json&page='+ current_page, success: function(result){
    let json_result = $.parseJSON(result);
    if( json_result.result_count > 0 ){

      let slideItems = [];
      $.each(json_result.results, function() {
        let title   = this.title,
            image   = this.image ? '<figure><img class="lazyload" data-src="'+ this.image +'" data-widths="[180, 360, 535, 720, 900, 1080, 1296, 1512, 1728, 2048]" data-aspectratio="1.0" data-sizes="auto" alt="'+ title +'"> </figure>' : '';
        let url
        if (this.url && this.url != '') {
          url = '<a href="'+ this.url +'"  title="'+ title.replace("<br>", "") +'" class="permalink" target="_blank" rel="noopener noreferrer"></a>' 
        } else if (this.article_url && this.article_url != '') {
          url = '<a href="'+ this.article_url +'"  title="'+ title.replace("<br>", "") +'" class="permalink" rel="noopener noreferrer"></a>' 
        } else {
          url = ''
        }
        let item = '<div class="slide-item"><div><div class="item-play"><div>'+ url + image +'<div class="label"><span>'+ title +'</span></div></div></div></div></div>';

        slideItems.push( item );
      });

      kids_play_slider.slick('slickAdd', slideItems.join(' ') );
      play_page++;
      formatDots( kids_play_slider );
    }
  }});
}

function start_play(){
  console.log( 'start_Play init....' );
  limitedDots( '.kids-play-slider' );

  kids_play_slider.on('init', function(slick){
    pull_play(1);
  });

  kids_play_slider.slick({
    // fade: true,
    infinite: false,
    slidesToShow: 3,
    slidesToScroll: 1,
    arrows: true,
    dots: true,
    prevArrow: '<span class="kids-arrow-prev"></span>',
    nextArrow: '<span class="kids-arrow-next"></span>',
    lazyLoad: 'progressive',
    responsive: [
      {
        breakpoint: 1160,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
        }
      },
      {
        breakpoint: 700,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1
        }
      },
    ]
  });
}


/**************************************************************************************/
/********* PUZZLES SLIDER
/**************************************************************************************/
const kids_puzzle_slider = $('.kids-puzzle-slider');
let   puzzle_page = 1;

function pull_puzzles(current_page){
  $.ajax({url: '/blogs/puzzles?view=puzzles-json&page='+ current_page, success: function(result){
    let json_result = $.parseJSON(result);
    if( json_result.result_count > 0 ){

      let slideItems = [];
      $.each(json_result.results, function() {
        let title   = this.title,
            image   = this.image ? '<figure><img class="lazyload" data-src="'+ this.image +'" data-widths="[180, 360, 535, 720, 900, 1080, 1296, 1512, 1728, 2048]" data-aspectratio="1.0" data-sizes="auto" alt="'+ title +'"> </figure>' : '',
            url   = this.url ? '<a href="'+ this.url +'"  title="'+ title +'" class="permalink"></a>' : '';

        let item = '<div class="slide-item"><div><div class="item-play"><div>'+ url + image +'<div class="label"><span>'+ title +'</span></div></div></div></div></div>';

        slideItems.push( item );
      });

      kids_puzzle_slider.slick('slickAdd', slideItems.join(' ') );
      puzzle_page++;
      formatDots( $('.kids-puzzle-slider') );
    }
  }});
}

function start_puzzles(){
  limitedDots( '.kids-puzzle-slider' );

  kids_puzzle_slider.on('init', function(slick){
    pull_puzzles(1);
  });

  kids_puzzle_slider.slick({
    // fade: true,
    infinite: false,
    slidesToShow: 3,
    slidesToScroll: 1,
    arrows: true,
    dots: true,
    prevArrow: '<span class="kids-arrow-prev"></span>',
    nextArrow: '<span class="kids-arrow-next"></span>',
    lazyLoad: 'progressive',
    responsive: [
      {
        breakpoint: 1160,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
        }
      },
      {
        breakpoint: 700,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1
        }
      },
    ]
  });
}


/**************************************************************************************/
/********* WATCH SLIDER -  All tab
/**************************************************************************************/
const watchAll = $('.watch-all');
const watchAllMob = $('.watch-all-mob');
let   watch_page = 1;

function pull_allWatch(current_page){
  $.ajax({url: '/blogs/videos?view=videos-json&page='+ current_page, success: function(result){
      let json_result = $.parseJSON(result);
      // console.log( 'json_result.result_count ' + json_result.result_count );
      // return false;
      if( json_result.result_count > 1 ){

          if( $(window).width() > 1200 ){

              $.each(json_result.results, function(index) {
                // console.log( this.slide_item );
                let slide_sub_items = [];
                // console.log( 'slide #' + index );
                $.each(this.slide_item, function(subindex) {
                  let aspectratio = '1.7777777777777777';
                  let slide_class = 'small';

                  if( subindex == 0 ){
                    aspectratio = '1.77947932618683';
                    slide_class = 'large';
                  }

                  slide_sub_items.push( '<div class="vid '+ slide_class +'"><figure><a class="permalink" href="'+ this.url +'" data-fancybox="" target="_blank" rel="noopener noreferrer"><span></span></a><img class="lazyload" data-src="'+ this.image +'" data-widths="[180, 360, 540, 720, 900, 1080, 1296, 1512, 1728, 2048]" data-aspectratio="'+ aspectratio +'" data-sizes="auto" alt="'+ this.title +'"></figure><div class="label"><span>'+ this.title +'</span></div></div>' );

                  if( subindex == 0 ){
                    slide_sub_items.push( '<div class="smalls">' );
                  }
                });

                watchAll.slick('slickAdd','<div class="slide-item"><div>'+ slide_sub_items.join('') +'</div></div></div>');
              });

          }else{

              let slideItems = [];
              $.each(json_result.results_mobile, function() {
                let title   = this.title,
                    image   = this.image ? '<img class="lazyload" data-src="'+ this.image +'" data-widths="[180, 360, 540, 720, 900, 1080, 1296, 1512, 1728, 2048]" data-aspectratio="1.7777777777777777" data-sizes="auto" alt="'+ title +'">' : '',
                    url = this.url ? '<a class="permalink" href="'+ this.url +'" data-fancybox="" target="_blank" rel="noopener noreferrer"><span></span></a>' : '';

                let item = '<div class="slide-item-mob"><div><div class="vid small"><figure>'+ url + image +'</figure><div class="label"><span>'+ title +'</span></div></div></div></div>';

                slideItems.push( item );
              });

              watchAllMob.slick('slickAdd', slideItems.join(' ') );
          }

          watch_page++;
          // pull_allWatch(watch_page);

          // $( document ).trigger( "pullingDone", [ 'watch-commercials' ] );

          if( $(window).width() > 1200 )
            formatDots( watchAll );
          else
            formatDots( watchAllMob );

      }
  }});
}

function start_watch_all(){
  if( $(window).width() > 1200 ){

    watchAll.on('init', function(slick){
      pull_allWatch(1);
      start_watch_commercials();
    });

    watchAll.slick({
      // adaptiveHeight: true,
      infinite: false,
      slidesToShow: 1,
      arrows: true,
      dots: true,
      prevArrow: '<span class="kids-arrow-prev"></span>',
      nextArrow: '<span class="kids-arrow-next"></span>',
      lazyLoad: 'progressive',
    });

  }else{

    watchAllMob.on('init', function(slick){
      pull_allWatch(1);
      start_watch_commercials();
    });

    watchAllMob.slick({
      // adaptiveHeight: true,
      infinite: false,
      slidesToShow: 2,
      slidesToScroll: 2,
      arrows: true,
      dots: true,
      prevArrow: '<span class="kids-arrow-prev"></span>',
      nextArrow: '<span class="kids-arrow-next"></span>',
      lazyLoad: 'progressive',
      responsive: [
        {
          breakpoint: 700,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1
          }
        }
      ]
    });

  }
}

/**************************************************************************************/
/********* WATCH SLIDER - Commercials tab
/**************************************************************************************/
const watchCommercials = $('.watch-commercials'),
      watchCommercialsMob = $('.watch-commercials-mob'),
      watchCommercialsTag = watchCommercials.data('tag');
let   commercials_page = 1;

function pull_commercials(current_page){
  $.ajax({url: '/blogs/videos/tagged/'+ watchCommercialsTag +'?view=videos-json&page='+ current_page, success: function(result){
    let json_result = $.parseJSON(result);
    // console.log( 'json_result.result_count ' + json_result.result_count );
    // return false;
    if( json_result.result_count > 1 ){

      if( $(window).width() > 1200 ){

          $.each(json_result.results, function(index) {
            // console.log( this.slide_item );
            let slide_sub_items = [];
            // console.log( 'slide #' + index );
            $.each(this.slide_item, function(subindex) {
              let aspectratio = '1.7777777777777777';
              let slide_class = 'small';

              if( subindex == 0 ){
                aspectratio = '1.77947932618683';
                slide_class = 'large';
              }

              slide_sub_items.push( '<div class="vid '+ slide_class +'"><figure><a class="permalink" href="'+ this.url +'" data-fancybox="" target="_blank" rel="noopener noreferrer"><span></span></a><img class="lazyload" data-src="'+ this.image +'" data-widths="[180, 360, 540, 720, 900, 1080, 1296, 1512, 1728, 2048]" data-aspectratio="'+ aspectratio +'" data-sizes="auto" alt="'+ this.title +'"></figure><div class="label"><span>'+ this.title +'</span></div></div>' );

              if( subindex == 0 ){
                slide_sub_items.push( '<div class="smalls">' );
              }
            });

            watchCommercials.slick('slickAdd','<div class="slide-item"><div>'+ slide_sub_items.join('') +'</div></div></div>');
          });

      }else{

          let slideItems = [];
          $.each(json_result.results_mobile, function() {
            let title   = this.title,
                image   = this.image ? '<img class="lazyload" data-src="'+ this.image +'" data-widths="[180, 360, 540, 720, 900, 1080, 1296, 1512, 1728, 2048]" data-aspectratio="1.7777777777777777" data-sizes="auto" alt="'+ title +'">' : '',
                url = this.url ? '<a class="permalink" href="'+ this.url +'" data-fancybox="" target="_blank" rel="noopener noreferrer"><span></span></a>' : '';

            let item = '<div class="slide-item-mob"><div><div class="vid small"><figure>'+ url + image +'</figure><div class="label"><span>'+ title +'</span></div></div></div></div>';

            slideItems.push( item );
          });

          watchCommercialsMob.slick('slickAdd', slideItems.join(' ') );
      }

      commercials_page++;
      // pull_commercials(commercials_page);
      if( $(window).width() > 1200 )
        formatDots( watchCommercials );
      else
        formatDots( watchCommercialsMob );

      // $( document ).trigger( "pullingDone", [ 'watch-demos' ] );

    }
  }});
}

function start_watch_commercials(){
  if( $(window).width() > 1200 ){

    limitedDots( '.watch-commercials' );

    watchCommercials.on('init', function(slick){
      pull_commercials(1);
      start_watch_demos();
    });

    watchCommercials.slick({
      // fade: true,
      infinite: false,
      slidesToShow: 1,
      arrows: true,
      dots: true,
      prevArrow: '<span class="kids-arrow-prev"></span>',
      nextArrow: '<span class="kids-arrow-next"></span>',
      lazyLoad: 'progressive',
    });

  }else{

    limitedDots( '.watch-commercials-mob' );

    watchCommercialsMob.on('init', function(slick){
      pull_commercials(1);
      start_watch_demos();
    });

    watchCommercialsMob.slick({
      // fade: true,
      infinite: false,
      slidesToShow: 2,
      slidesToScroll: 1,
      arrows: true,
      dots: true,
      adaptiveHeight: false,
      prevArrow: '<span class="kids-arrow-prev"></span>',
      nextArrow: '<span class="kids-arrow-next"></span>',
      lazyLoad: 'progressive',
      responsive: [
        {
          breakpoint: 700,
          settings: {
            adaptiveHeight: true,
            slidesToShow: 1,
            slidesToScroll: 1
          }
        }
      ]
    });

  }
}

/**************************************************************************************/
/********* WATCH SLIDER - Demos tab
/**************************************************************************************/
const watchDemos = $('.watch-demos'),
      watchDemosMob = $('.watch-demos-mob'),
      watchDemosTag = watchDemos.data('tag');
let   demos_page = 1;

function pull_demos(current_page){
  $.ajax({url: '/blogs/videos/tagged/'+ watchDemosTag +'?view=videos-json&page='+ current_page, success: function(result){
          let json_result = $.parseJSON(result);
          // console.log( 'json_result.result_count ' + json_result.result_count );
          // return false;
          if( json_result.result_count > 1 ){

            if( $(window).width() > 1200 ){

                $.each(json_result.results, function(index) {
                  // console.log( this.slide_item );
                  let slide_sub_items = [];
                  // console.log( 'slide #' + index );
                  $.each(this.slide_item, function(subindex) {
                    let aspectratio = '1.7777777777777777';
                    let slide_class = 'small';

                    if( subindex == 0 ){
                      aspectratio = '1.77947932618683';
                      slide_class = 'large';
                    }

                    slide_sub_items.push( '<div class="vid '+ slide_class +'"><figure><a class="permalink" href="'+ this.url +'" data-fancybox="" target="_blank" rel="noopener noreferrer"><span></span></a><img class="lazyload" data-src="'+ this.image +'" data-widths="[180, 360, 540, 720, 900, 1080, 1296, 1512, 1728, 2048]" data-aspectratio="'+ aspectratio +'" data-sizes="auto" alt="'+ this.title +'"></figure><div class="label"><span>'+ this.title +'</span></div></div>' );

                    if( subindex == 0 ){
                      slide_sub_items.push( '<div class="smalls">' );
                    }
                  });

                  watchDemos.slick('slickAdd','<div class="slide-item"><div>'+ slide_sub_items.join('') +'</div></div></div>');
                });

            }else{

                let slideItems = [];
                $.each(json_result.results_mobile, function() {
                  let title   = this.title,
                      image   = this.image ? '<img class="lazyload" data-src="'+ this.image +'" data-widths="[180, 360, 540, 720, 900, 1080, 1296, 1512, 1728, 2048]" data-aspectratio="1.7777777777777777" data-sizes="auto" alt="'+ title +'">' : '',
                      url = this.url ? '<a class="permalink" href="'+ this.url +'" data-fancybox="" target="_blank" rel="noopener noreferrer"><span></span></a>' : '';

                  let item = '<div class="slide-item-mob"><div><div class="vid small"><figure>'+ url + image +'</figure><div class="label"><span>'+ title +'</span></div></div></div></div>';

                  slideItems.push( item );
                });

                watchDemosMob.slick('slickAdd', slideItems.join(' ') );
            }

            demos_page++;
            // pull_demos(demos_page);
            if( $(window).width() > 1200 )
              formatDots( watchDemos );
            else
              formatDots( watchDemosMob );

            $( document ).trigger( "pullingDone", [ 'watch-makeovers' ] );

          }
  }});
}

function start_watch_demos(){
  if( $(window).width() > 1200 ){

    limitedDots( '.watch-demos' );

    watchDemos.on('init', function(slick){
      pull_demos(1);
      start_watch_makeovers();
    });

    watchDemos.slick({
      // fade: true,
      infinite: false,
      slidesToShow: 1,
      arrows: true,
      dots: true,
      prevArrow: '<span class="kids-arrow-prev"></span>',
      nextArrow: '<span class="kids-arrow-next"></span>',
      lazyLoad: 'progressive',
    });

  }else{

    limitedDots( '.watch-demos-mob' );

    watchDemosMob.on('init', function(slick){
      pull_demos(1);
      start_watch_makeovers();
    });

    watchDemosMob.slick({
      // fade: true,
      infinite: false,
      slidesToShow: 2,
      slidesToScroll: 1,
      arrows: true,
      dots: true,
      prevArrow: '<span class="kids-arrow-prev"></span>',
      nextArrow: '<span class="kids-arrow-next"></span>',
      lazyLoad: 'progressive',
      responsive: [
        {
          breakpoint: 700,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1
          }
        }
      ]
    });

  }
}

/**************************************************************************************/
/********* WATCH SLIDER - Makeovers tab
/**************************************************************************************/
const watchMakeovers = $('.watch-makeovers'),
      watchMakeoversMob = $('.watch-makeovers-mob'),
      watchMakeoversTag = watchMakeovers.data('tag');
let   makeover_page = 1;

function pull_makeovers(current_page){
  $.ajax({url: '/blogs/videos/tagged/'+ watchMakeoversTag +'?view=videos-json&page='+ current_page, success: function(result){
    let json_result = $.parseJSON(result);
    // console.log( 'json_result.result_count ' + json_result.result_count );
    // return false;
    if( json_result.result_count > 1 ){

      if( $(window).width() > 1200 ){

          $.each(json_result.results, function(index) {
            // console.log( this.slide_item );
            let slide_sub_items = [];
            // console.log( 'slide #' + index );
            $.each(this.slide_item, function(subindex) {
              let aspectratio = '1.7777777777777777';
              let slide_class = 'small';

              if( subindex == 0 ){
                aspectratio = '1.77947932618683';
                slide_class = 'large';
              }

              slide_sub_items.push( '<div class="vid '+ slide_class +'"><figure><a class="permalink" href="'+ this.url +'" data-fancybox="" target="_blank" rel="noopener noreferrer"><span></span></a><img class="lazyload" data-src="'+ this.image +'" data-widths="[180, 360, 540, 720, 900, 1080, 1296, 1512, 1728, 2048]" data-aspectratio="'+ aspectratio +'" data-sizes="auto" alt="'+ this.title +'"></figure><div class="label"><span>'+ this.title +'</span></div></div>' );

              if( subindex == 0 ){
                slide_sub_items.push( '<div class="smalls">' );
              }
            });

            watchMakeovers.slick('slickAdd','<div class="slide-item"><div>'+ slide_sub_items.join('') +'</div></div></div>');
          });

      }else{

          let slideItems = [];
          $.each(json_result.results_mobile, function() {
            let title   = this.title,
                image   = this.image ? '<img class="lazyload" data-src="'+ this.image +'" data-widths="[180, 360, 540, 720, 900, 1080, 1296, 1512, 1728, 2048]" data-aspectratio="1.7777777777777777" data-sizes="auto" alt="'+ title +'">' : '',
                url = this.url ? '<a class="permalink" href="'+ this.url +'" data-fancybox="" target="_blank" rel="noopener noreferrer"><span></span></a>' : '';

            let item = '<div class="slide-item-mob"><div><div class="vid small"><figure>'+ url + image +'</figure><div class="label"><span>'+ title +'</span></div></div></div></div>';

            slideItems.push( item );
          });

          watchMakeoversMob.slick('slickAdd', slideItems.join(' ') );
      }

      makeover_page++;
      // pull_makeovers(makeover_page);
      if( $(window).width() > 1200 )
        formatDots( watchMakeovers );
      else
        formatDots( watchMakeoversMob );

      // $( document ).trigger( "pullingDone", [ 'watch-omg' ] );

    }
  }});
}

function start_watch_makeovers(){
  if( $(window).width() > 1200 ){

    limitedDots( '.watch-makeovers' );

    watchMakeovers.on('init', function(slick){
      pull_makeovers(1);
      start_watch_omg();
    });

    watchMakeovers.slick({
      infinite: false,
      slidesToShow: 1,
      arrows: true,
      dots: true,
      prevArrow: '<span class="kids-arrow-prev"></span>',
      nextArrow: '<span class="kids-arrow-next"></span>',
      lazyLoad: 'progressive',
    });

  }else{

    limitedDots( '.watch-makeovers-mob' );

    watchMakeoversMob.on('init', function(slick){
      pull_makeovers(1);
      start_watch_omg();
    });

    watchMakeoversMob.slick({
      infinite: false,
      slidesToShow: 2,
      slidesToScroll: 1,
      arrows: true,
      dots: true,
      prevArrow: '<span class="kids-arrow-prev"></span>',
      nextArrow: '<span class="kids-arrow-next"></span>',
      lazyLoad: 'progressive',
      responsive: [
        {
          breakpoint: 700,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1
          }
        }
      ]
    });
  }
}

/**************************************************************************************/
/********* WATCH SLIDER - OMG tab
/**************************************************************************************/
const watchOMG = $('.watch-omg'),
      watchOMGMob = $('.watch-omg-mob'),
      watchOMGTag = watchOMG.data('tag');
let   omgs_page = 1;

function pull_omgs(current_page){
  $.ajax({url: '/blogs/videos/tagged/'+ watchOMGTag +'?view=videos-json&page='+ current_page, success: function(result){
    let json_result = $.parseJSON(result);
    // console.log( 'json_result.result_count ' + json_result.result_count );
    // return false;
    if( json_result.result_count > 1 ){

      if( $(window).width() > 1200 ){

          $.each(json_result.results, function(index) {
            // console.log( this.slide_item );
            let slide_sub_items = [];
            // console.log( 'slide #' + index );
            $.each(this.slide_item, function(subindex) {
              let aspectratio = '1.7777777777777777';
              let slide_class = 'small';

              if( subindex == 0 ){
                aspectratio = '1.77947932618683';
                slide_class = 'large';
              }

              slide_sub_items.push( '<div class="vid '+ slide_class +'"><figure><a class="permalink" href="'+ this.url +'" data-fancybox="" target="_blank" rel="noopener noreferrer"><span></span></a><img class="lazyload" data-src="'+ this.image +'" data-widths="[180, 360, 540, 720, 900, 1080, 1296, 1512, 1728, 2048]" data-aspectratio="'+ aspectratio +'" data-sizes="auto" alt="'+ this.title +'"></figure><div class="label"><span>'+ this.title +'</span></div></div>' );

              if( subindex == 0 ){
                slide_sub_items.push( '<div class="smalls">' );
              }
            });

            watchOMG.slick('slickAdd','<div class="slide-item"><div>'+ slide_sub_items.join('') +'</div></div></div>');
          });

      }else{

          let slideItems = [];
          $.each(json_result.results_mobile, function() {
            let title   = this.title,
                image   = this.image ? '<img class="lazyload" data-src="'+ this.image +'" data-widths="[180, 360, 540, 720, 900, 1080, 1296, 1512, 1728, 2048]" data-aspectratio="1.7777777777777777" data-sizes="auto" alt="'+ title +'">' : '',
                url = this.url ? '<a class="permalink" href="'+ this.url +'" data-fancybox="" target="_blank" rel="noopener noreferrer"><span></span></a>' : '';

            let item = '<div class="slide-item-mob"><div><div class="vid small"><figure>'+ url + image +'</figure><div class="label"><span>'+ title +'</span></div></div></div></div>';

            slideItems.push( item );
          });

          watchOMGMob.slick('slickAdd', slideItems.join(' ') );
      }

      omgs_page++;
      // pull_omgs(omgs_page);
      if( $(window).width() > 1200 )
        formatDots( watchOMG );
      else
        formatDots( watchOMGMob );

      // $( document ).trigger( "pullingDone", [ 'watch-playsodes' ] );

    }
  }});
}

function start_watch_omg(){
  if( $(window).width() > 1200 ){

    limitedDots( '.watch-omg' );

    watchOMG.on('init', function(slick){
      pull_omgs(1);
      start_watch_playisodes();
    });

    watchOMG.slick({
      infinite: false,
      slidesToShow: 1,
      arrows: true,
      dots: true,
      prevArrow: '<span class="kids-arrow-prev"></span>',
      nextArrow: '<span class="kids-arrow-next"></span>',
      lazyLoad: 'progressive',
    });

  }else{

    limitedDots( '.watch-omg-mob' );

    watchOMGMob.on('init', function(slick){
      pull_omgs(1);
      start_watch_playisodes();
    });

    watchOMGMob.slick({
      infinite: false,
      slidesToShow: 2,
      slidesToScroll: 1,
      arrows: true,
      dots: true,
      prevArrow: '<span class="kids-arrow-prev"></span>',
      nextArrow: '<span class="kids-arrow-next"></span>',
      lazyLoad: 'progressive',
      responsive: [
        {
          breakpoint: 700,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1
          }
        }
      ]
    });
  }
}


/**************************************************************************************/
/********* WATCH SLIDER - Playisodes tab
/**************************************************************************************/
const watchPlaysodes = $('.watch-playsodes'),
      watchPlaysodesMob = $('.watch-playsodes-mob'),
      watchPlaysodesTag = watchPlaysodes.data('tag');
let   playsodes_page = 1;

function pull_playsodes(current_page){
  $.ajax({url: '/blogs/videos/tagged/'+ watchPlaysodesTag +'?view=videos-json&page='+ current_page, success: function(result){
    let json_result = $.parseJSON(result);
    // console.log( 'json_result.result_count ' + json_result.result_count );
    // return false;
    if( json_result.result_count > 1 ){

      if( $(window).width() > 1200 ){

          $.each(json_result.results, function(index) {
            // console.log( this.slide_item );
            let slide_sub_items = [];
            // console.log( 'slide #' + index );
            $.each(this.slide_item, function(subindex) {
              let aspectratio = '1.7777777777777777';
              let slide_class = 'small';

              if( subindex == 0 ){
                aspectratio = '1.77947932618683';
                slide_class = 'large';
              }

              slide_sub_items.push( '<div class="vid '+ slide_class +'"><figure><a class="permalink" href="'+ this.url +'" data-fancybox="" target="_blank" rel="noopener noreferrer"><span></span></a><img class="lazyload" data-src="'+ this.image +'" data-widths="[180, 360, 540, 720, 900, 1080, 1296, 1512, 1728, 2048]" data-aspectratio="'+ aspectratio +'" data-sizes="auto" alt="'+ this.title +'"></figure><div class="label"><span>'+ this.title +'</span></div></div>' );

              if( subindex == 0 ){
                slide_sub_items.push( '<div class="smalls">' );
              }
            });

            watchPlaysodes.slick('slickAdd','<div class="slide-item"><div>'+ slide_sub_items.join('') +'</div></div></div>');
          });

      }else{

          let slideItems = [];
          $.each(json_result.results_mobile, function() {
            let title   = this.title,
                image   = this.image ? '<img class="lazyload" data-src="'+ this.image +'" data-widths="[180, 360, 540, 720, 900, 1080, 1296, 1512, 1728, 2048]" data-aspectratio="1.7777777777777777" data-sizes="auto" alt="'+ title +'">' : '',
                url = this.url ? '<a class="permalink" href="'+ this.url +'" data-fancybox="" target="_blank" rel="noopener noreferrer"><span></span></a>' : '';

            let item = '<div class="slide-item-mob"><div><div class="vid small"><figure>'+ url + image +'</figure><div class="label"><span>'+ title +'</span></div></div></div></div>';

            slideItems.push( item );
          });

          watchPlaysodesMob.slick('slickAdd', slideItems.join(' ') );
      }

      playsodes_page++;
      // pull_playsodes(playsodes_page);
      if( $(window).width() > 1200 )
        formatDots( watchPlaysodes );
      else
        formatDots( watchPlaysodesMob );

      // $( document ).trigger( "pullingDone", [ 'watch-unboxed' ] );

    }
  }});
}

function start_watch_playisodes(){
  if( $(window).width() > 1200 ){

    limitedDots( '.watch-playsodes' );

    watchPlaysodes.on('init', function(slick){
      pull_playsodes(1);
      start_watch_unboxed();
    });

    watchPlaysodes.slick({
      // fade: true,
      infinite: false,
      slidesToShow: 1,
      arrows: true,
      dots: true,
      prevArrow: '<span class="kids-arrow-prev"></span>',
      nextArrow: '<span class="kids-arrow-next"></span>',
      lazyLoad: 'progressive',
    });

  }else{

    limitedDots( '.watch-playsodes-mob' );

    watchPlaysodesMob.on('init', function(slick){
      pull_playsodes(1);
      start_watch_unboxed();
    });

    watchPlaysodesMob.slick({
      // fade: true,
      infinite: false,
      slidesToShow: 2,
      slidesToScroll: 1,
      arrows: true,
      dots: true,
      prevArrow: '<span class="kids-arrow-prev"></span>',
      nextArrow: '<span class="kids-arrow-next"></span>',
      lazyLoad: 'progressive',
      responsive: [
        {
          breakpoint: 700,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1
          }
        }
      ]
    });
  }
}


/**************************************************************************************/
/********* WATCH SLIDER - Unboxed tab
/**************************************************************************************/
const watchUnboxed = $('.watch-unboxed'),
      watchUnboxedMob = $('.watch-unboxed-mob'),
      watchUnboxedTag = watchUnboxed.data('tag');
let   unboxed_page = 1;

function pull_unboxed(current_page){
  $.ajax({url: '/blogs/videos/tagged/'+ watchUnboxedTag +'?view=videos-json&page='+ current_page, success: function(result){
    let json_result = $.parseJSON(result);
    // console.log( 'json_result.result_count ' + json_result.result_count );
    // return false;
    if( json_result.result_count > 1 ){

      if( $(window).width() > 1200 ){

          $.each(json_result.results, function(index) {
            // console.log( this.slide_item );
            let slide_sub_items = [];
            // console.log( 'slide #' + index );
            $.each(this.slide_item, function(subindex) {
              let aspectratio = '1.7777777777777777';
              let slide_class = 'small';

              if( subindex == 0 ){
                aspectratio = '1.77947932618683';
                slide_class = 'large';
              }

              slide_sub_items.push( '<div class="vid '+ slide_class +'"><figure><a class="permalink" href="'+ this.url +'" data-fancybox="" target="_blank" rel="noopener noreferrer"><span></span></a><img class="lazyload" data-src="'+ this.image +'" data-widths="[180, 360, 540, 720, 900, 1080, 1296, 1512, 1728, 2048]" data-aspectratio="'+ aspectratio +'" data-sizes="auto" alt="'+ this.title +'"></figure><div class="label"><span>'+ this.title +'</span></div></div>' );

              if( subindex == 0 ){
                slide_sub_items.push( '<div class="smalls">' );
              }
            });

            watchUnboxed.slick('slickAdd','<div class="slide-item"><div>'+ slide_sub_items.join('') +'</div></div></div>');
          });

      }else{

          let slideItems = [];
          $.each(json_result.results_mobile, function() {
            let title   = this.title,
                image   = this.image ? '<img class="lazyload" data-src="'+ this.image +'" data-widths="[180, 360, 540, 720, 900, 1080, 1296, 1512, 1728, 2048]" data-aspectratio="1.7777777777777777" data-sizes="auto" alt="'+ title +'">' : '',
                url = this.url ? '<a class="permalink" href="'+ this.url +'" data-fancybox="" target="_blank" rel="noopener noreferrer"><span></span></a>' : '';

            let item = '<div class="slide-item-mob"><div><div class="vid small"><figure>'+ url + image +'</figure><div class="label"><span>'+ title +'</span></div></div></div></div>';

            slideItems.push( item );
          });

          watchUnboxedMob.slick('slickAdd', slideItems.join(' ') );
      }

      unboxed_page++;
      // pull_unboxed(unboxed_page);
      if( $(window).width() > 1200 )
        formatDots( watchUnboxed );
      else
        formatDots( watchUnboxedMob );

    }
  }});
}

function start_watch_unboxed(){
  if( $(window).width() > 1200 ){

    limitedDots( '.watch-unboxed' );

    watchUnboxed.on('init', function(slick){
      pull_unboxed(1);
    });

    watchUnboxed.slick({
      infinite: false,
      slidesToShow: 1,
      arrows: true,
      dots: true,
      prevArrow: '<span class="kids-arrow-prev"></span>',
      nextArrow: '<span class="kids-arrow-next"></span>',
      lazyLoad: 'progressive',
    });

  }else{

    limitedDots( '.watch-unboxed-mob' );

    watchUnboxedMob.on('init', function(slick){
      pull_unboxed(1);
    });

    watchUnboxedMob.slick({
      infinite: false,
      slidesToShow: 2,
      slidesToScroll: 1,
      arrows: true,
      dots: true,
      prevArrow: '<span class="kids-arrow-prev"></span>',
      nextArrow: '<span class="kids-arrow-next"></span>',
      lazyLoad: 'progressive',
      responsive: [
        {
          breakpoint: 700,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1
          }
        }
      ]
    });
  }
}




/**************************************************************************************/
/********* QUIZZES SLIDER
/**************************************************************************************/
const kids_quiz_slider = $('.kids-quiz-slider');
let quiz_page = 1;
function pull_quiz(current_page){
  $.ajax({url: '/blogs/quizzes?view=quizzes-json&page='+ current_page, success: function(result){
    let json_result = $.parseJSON(result);
    if( json_result.result_count > 0 ){

      let slideItems = [];
      $.each(json_result.results, function() {
        let title   = this.title,
            image   = this.image ? '<figure><img class="lazyload" data-src="'+ this.image +'" data-widths="[180, 500, 540, 720, 900, 1080, 1296, 1512, 1728, 2048]" data-aspectratio="0.8645038167938931" data-sizes="auto" alt="'+ title +'"></figure>' : '',
            bg_image   = this.bg_image ? '<div class="placeholder"><img class="lazyload" data-src="'+ this.bg_image +'"></div>' : '',
            url   = this.url;

        let item = '<div class="slide-item"><div><div class="item">'+ image + bg_image +'<div class="label"><span class="q-mark"><img src="'+ json_result.qmark +'" alt=""></span><span>'+ title +'</span><a href="'+ url +'" class="btn" title="'+ title.replace("<br>", "") +'">Take Quiz</a></div></div></div></div>';

        slideItems.push( item );
      });
      kids_quiz_slider.slick('slickAdd', slideItems.join(' ') );
      quiz_page++;
      // pull_quiz(quiz_page);
      formatDots( kids_quiz_slider );
      // console.log( slideItems.join(' ') );
    }
  }});
}

function start_quizzes(){
  limitedDots( '.kids-quiz-slider' );

  kids_quiz_slider.on('init', function(slick){
    pull_quiz(1);
  });

  kids_quiz_slider.slick({
    // fade: true,
    infinite: false,
    slidesToShow: 2,
    slidesToScroll: 1,
    arrows: true,
    dots: true,
    prevArrow: '<span class="kids-arrow-prev"></span>',
    nextArrow: '<span class="kids-arrow-next"></span>',
    lazyLoad: 'progressive',
    responsive: [
      {
        breakpoint: 760,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1
        }
      }
    ]
  });
}




/**************************************************************************************/
/********* COLLECT SLIDER
/**************************************************************************************/
const kids_collect_slider = $('.kids-collect-slider'),
      kids_collect_slider_mobile = $('.kids-collect-slider-mobile');

function start_collect(){

  if( $(window).width() > 1200 ){

    limitedDots( '.kids-collect-slider' );

    kids_collect_slider.on('init', function(slick){
      // pull_json_collections(1);
      setTimeout(function(){
        pull_json_collections(1);
      },1000);
      // console.log( 'kids_collect_slider loaded.... ' );
    });

    kids_collect_slider.slick({
      // fade: true,
      infinite: false,
      slidesToShow: 1,
      arrows: true,
      dots: true,
      prevArrow: '<span class="kids-arrow-prev"></span>',
      nextArrow: '<span class="kids-arrow-next"></span>',
      lazyLoad: 'progressive',
    });

  }else{

    limitedDots( '.kids-collect-slider-mobile' );

    kids_collect_slider_mobile.on('init', function(slick){
      setTimeout(function(){
        pull_json_collections(1);
      },1000);
    });

    kids_collect_slider_mobile.slick({
      // fade: true,
      infinite: false,
      slidesToShow: 3,
      slidesToScroll: 1,
      arrows: true,
      dots: true,
      prevArrow: '<span class="kids-arrow-prev"></span>',
      nextArrow: '<span class="kids-arrow-next"></span>',
      lazyLoad: 'progressive',
      responsive: [
        {
          breakpoint: 760,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 1
          }
        }
      ]
    });

  }
}





/**************************************************************************************/
/********* LOL OMG SLIDER
/**************************************************************************************/
const kids_omg_slider = $('.kids-omg-slider');
let   omg_page = 1;

function pull_omg(current_page){
  $.ajax({url: '/blogs/omg?view=omg-json&page='+ current_page, success: function(result){
    let json_result = $.parseJSON(result);
    if( json_result.result_count > 0 ){

      let slideItems = [];
      $.each(json_result.results, function() {
        let title   = this.title,
            image   = this.image ? '<figure><img class="lazyload" data-src="'+ this.image +'" data-widths="[180, 360, 534, 720, 900, 1080, 1296, 1512, 1728, 2048]" data-aspectratio="0.7665198237885462" data-sizes="auto" alt="'+ title +'"></figure>' : '',
            image_dl = this.image_dl ? '<a href="'+ this.image_dl +'" target="_blank" rel="noopener noreferrer" class="permalink" title="Download card"></a>' : '';

        let item = '<div class="slide-item"><div><div class="item item-omg">'+ image +'</div></div></div>';
        slideItems.push( item );
      });
      kids_omg_slider.slick('slickAdd', slideItems.join(' ') );
      omg_page++;
      formatDots( kids_omg_slider );
    }
  }});
}

function start_omg(){
  // console.log( 'start_omg' );
  limitedDots( '.kids-omg-slider' );

  kids_omg_slider.on('init', function(slick){
    pull_omg(1);
  });

  kids_omg_slider.slick({
    // fade: true,
    infinite: false,
    slidesToShow: 2,
    slidesToScroll: 1,
    arrows: true,
    dots: true,
    prevArrow: '<span class="kids-arrow-prev"></span>',
    nextArrow: '<span class="kids-arrow-next"></span>',
    lazyLoad: 'progressive',
    responsive: [
      {
        breakpoint: 650,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1
        }
      }
    ]
  });
}




/**************************************************************************************/
/********* PRINT SLIDER
/**************************************************************************************/
function start_print(){
  $('.kids-print-slider').slick({
    // fade: true,
    infinite: false,
    slidesToShow: 2,
    slidesToScroll: 1,
    arrows: true,
    dots: false,
    prevArrow: '<span class="kids-arrow-prev"></span>',
    nextArrow: '<span class="kids-arrow-next"></span>',
    lazyLoad: 'progressive',
    responsive: [
      {
        breakpoint: 700,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1
        }
      }
    ]
  });
}




/**************************************************************************************/
/********* SHOP SLIDER
/**************************************************************************************/
const kids_hot_slider = $('.kids-hot-slider');
let   products_page = 1;

function pull_products(current_page){
  $.ajax({url: '/blogs/hot-products?view=hot-prod-json&page='+ current_page, success: function(result){
      let json_result = $.parseJSON(result);
      if( json_result.result_count > 0 ){

        let slideItems = [];
        $.each(json_result.results, function() {
          let title   = this.title,
              image   = this.image ? '<figure><img class="lazyload" data-src="'+ this.image +'" data-widths="[180, 360, 540, 720, 900, 1080, 1296, 1512, 1728, 2048]" data-aspectratio="0.8333333333333334" data-sizes="auto" alt="'+ title +'"></figure>' : '',
              shop_url = this.shop_url ? '<a href="#" data-tourl="'+ this.shop_url +'" class="btn" target="_blank" rel="noopener noreferrer">Shop Now</a>' : '';

          let item = '<div class="slide-item"><div><div>'+ image +'<div class="text"><span>'+ title +'</span></div>'+ shop_url +'</div></div></div>';

          slideItems.push( item );
        });
        kids_hot_slider.slick('slickAdd', slideItems.join(' ') );
        products_page++;
        formatDots( kids_hot_slider );
      }
  }});
}

function start_products(){
  limitedDots( '.kids-hot-slider' );

  kids_hot_slider.on('init', function(slick){
    pull_products(1);
  });

  kids_hot_slider.slick({
    // fade: true,
    infinite: false,
    slidesToShow: 3,
    slidesToScroll: 1,
    arrows: true,
    dots: true,
    prevArrow: '<span class="kids-arrow-prev"></span>',
    nextArrow: '<span class="kids-arrow-next"></span>',
    lazyLoad: 'progressive',
    responsive: [
      {
        breakpoint: 1200,
        settings: {
          arrows: true,
          slidesToShow: 2,
          slidesToScroll: 1
        }
      },
      {
        breakpoint: 600,
        settings: {
          arrows: false,
          slidesToShow: 1,
          slidesToScroll: 1
        }
      }
    ]
  });
}




/**************************************************************************************/
/********* LIKE SLIDER
/**************************************************************************************/
const kids_like_slider = $('.kids-like-slider');
function start_like(){
  kids_like_slider.on('init', function(slick){
    setTimeout(selectHearted,200);
  });

  kids_like_slider.slick({
    // fade: true,
    infinite: true,
    slidesToShow: 3,
    slidesToScroll: 3,
    initialSlide: 1,
    arrows: true,
    dots: false,
    variableWidth: true,
    prevArrow: '<span class="kids-arrow-prev"></span>',
    nextArrow: '<span class="kids-arrow-next"></span>',
    lazyLoad: 'progressive',
    responsive: [
      {
        breakpoint: 1000,
        settings: {
          variableWidth: false,
          slidesToShow: 4,
          slidesToScroll: 4
        }
      },
      {
        breakpoint: 760,
        settings: {
          variableWidth: false,
          slidesToShow: 3,
          slidesToScroll: 3
        }
      },
      {
        breakpoint: 600,
        settings: {
          variableWidth: false,
          slidesToShow: 2,
          slidesToScroll: 2
        }
      },
      {
        breakpoint: 500,
        settings: {
          variableWidth: false,
          slidesToShow: 1,
          slidesToScroll: 1
        }
      }
    ]
  });
}





/**************************************************************************************/
/********* APPS SLIDER
/**************************************************************************************/
function start_apps(){
  $('.kids-apps-slider').slick({
    // fade: true,
    infinite: false,
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: true,
    dots: false,
    prevArrow: '<span class="kids-arrow-prev"></span>',
    nextArrow: '<span class="kids-arrow-next"></span>',
    lazyLoad: 'progressive',
  });
}








if( $('.kids-fwatch-slider').length ){
  $('.kids-fwatch-slider').slick({
    // fade: true,
    infinite: false,
    slidesToShow: 1,
    arrows: true,
    dots: true,
    prevArrow: '<span class="kids-arrow-prev"></span>',
    nextArrow: '<span class="kids-arrow-next"></span>',
    lazyLoad: 'progressive',
  });
}

// limit slider dots to 5
function limitedDots(slider){
  // console.log( 'limitedDots.... ' + slider );
  $(slider).on('init', function (event, slick) {
    formatDots(slider);
  });

  setDotChange(slider);
}

function formatDots(slider){
  // console.log( 'format dots -- ' + $(slider).attr('id') );
  // $(slider).find('.slick-dots-container').remove();
  // console.log( 'slick-dots-container removed...' );
  if( $(slider).find('.slick-dots-container').is(':empty') ){
    $(slider).find('.slick-dots-container').remove();
  }
  $(slider).find('ul.slick-dots').wrap('<div class="slick-dots-container"></div>');
  $(slider).find('ul.slick-dots li').each(function (index) {
    // console.log( 'looping..... ' + index );
    $(this).addClass('dot-index-' + index);
    if( $(this).is(':nth-last-child(3)') ){
      $(this).addClass('dot-trigger');
    }
  });

  if( $(slider).find('ul.slick-dots li').length < 5 ){
    $(slider).find('ul.slick-dots').addClass('center');
  }

  $(slider).find('ul.slick-dots').css('transform', 'translateX(0)');

  setBoundries($(slider),'default');
  setDotChange(slider);
}

function setBoundries(slick, state) {
  if (state === 'default') {
    slick.find('ul.slick-dots li').eq(4).addClass('n-small-1');
  }
}

function setDotChange(slider){
  var transformCount = 0;

  $(slider).unbind( 'beforeChange' );
  // Slick Selector.
  var maxDots = 5;
  var transformXIntervalNext = -41;
  var transformXIntervalPrev = 41;

  if( $(slider).attr('data-transformcount') ){
    // console.log( 'prev transformcount ' + $(slider).attr('data-transformcount') );
    transformCount = parseInt( $(slider).attr('data-transformcount') );
    $(slider).find('ul.slick-dots').css('transform', 'translateX('+ transformCount +'px)');
    $(slider).find('ul.slick-dots li.dot-index-' + $(slider).attr('data-nextslide')).next('li').addClass('n-small-1');
  }

  // console.log( slider );

  $(slider).on('beforeChange', function (event, slick, currentSlide, nextSlide) {
    // console.log( 'changed....' + $(slider).attr('id') );

    var totalCount = $(this).find('.slick-dots li').length;
    // console.log( nextSlide + ' --- ' + currentSlide + ' --- ' + totalCount  + ' --- ' + maxDots );
    if (totalCount > maxDots) {
      if (nextSlide > currentSlide) {
        // console.log( 'nextSlide > currentSlide if.....' + nextSlide );
        if ($(this).find('ul.slick-dots li.dot-index-' + nextSlide).hasClass('dot-trigger')) {
          // console.log('trigger next pull........ ' + $(slider).attr('id') );
          let targetID = $(slider).attr('id');
          $( document ).trigger( "pullingDone", [ targetID ] );
        }

        if ($(this).find('ul.slick-dots li.dot-index-' + nextSlide).hasClass('n-small-1')) {
          // console.log( 'hasClass n-small-1 if.....' );
          if (!$(this).find('ul.slick-dots li:last-child').hasClass('n-small-1')) {
            // console.log('move right');
            transformCount = transformCount + transformXIntervalNext;
            $(this).find('ul.slick-dots li.dot-index-' + nextSlide).removeClass('n-small-1');
            var nextSlidePlusOne = nextSlide + 1;
            $(this).find('ul.slick-dots li.dot-index-' + nextSlidePlusOne).addClass('n-small-1');
            $(this).find('ul.slick-dots').css('transform', 'translateX(' + transformCount + 'px)');
            var pPointer = nextSlide - 3;
            var pPointerMinusOne = pPointer - 1;
            $(this).find('ul.slick-dots li').eq(pPointerMinusOne).removeClass('p-small-1');
            $(this).find('ul.slick-dots li').eq(pPointer).addClass('p-small-1');
          }
        }
      }
      else {
        if ($(this).find('ul.slick-dots li.dot-index-' + nextSlide).hasClass('p-small-1')) {
          if (!$(this).find('ul.slick-dots li:first-child').hasClass('p-small-1')) {
            // console.log('move left');
            transformCount = transformCount + transformXIntervalPrev;
            $(this).find('ul.slick-dots li.dot-index-' + nextSlide).removeClass('p-small-1');
            var nextSlidePlusOne = nextSlide - 1;
            $(this).find('ul.slick-dots li.dot-index-' + nextSlidePlusOne).addClass('p-small-1');
            $(this).find('ul.slick-dots').css('transform', 'translateX(' + transformCount + 'px)');
            var nPointer = currentSlide + 3;
            var nPointerMinusOne = nPointer - 1;
            $(this).find('ul.slick-dots li').eq(nPointer).removeClass('n-small-1');
            $(this).find('ul.slick-dots li').eq(nPointerMinusOne).addClass('n-small-1');
          }
        }
      }
    }
    $(this).attr('data-transformcount', transformCount );
    $(this).attr('data-nextslide', nextSlide );
    // console.log( 'transformCount ' + transformCount );
  });
}

$('.watch-cats a').on('click',function(){
  let $this = $(this),
    anchor = $this.data('anchor'),
    vidContent = $('.vid-content');

  var pos = $this.position();

  // console.log( 'left ' + pos.left );
  $this.parents('.cats').animate({scrollLeft: pos.left - 30 }, 500);

  $this.siblings().removeClass('active');
  vidContent.removeClass('visible');

  $this.addClass('active');
  $('.vid-content[data-target="' + anchor + '"]').addClass('visible');

  return false;
});


let to_print = 0;
let keyword = null;
const collections = $('#collections');
const no_results = $('.no-results');
const row_filters = $('.row-filters');
const sec_collect = $('.sec-collect');

let wanted = [];

$(document).on('click','.item-collect .btn-like',function(){
  let want = $(this).parent().data('want');

  $(this).parent().toggleClass('selected');

  if( $.inArray( want, wanted ) >= 0 ){
    wanted = $.grep(wanted, function(value) {
      return value != want;
    });
  }else{
    wanted.push( $(this).parent().data('want') );
  }

  // console.log( 'wanted' );
  // console.log( wanted );

  sessionStorage.setItem('wantedCollect', JSON.stringify(wanted));

  to_print = wanted.length;
  // console.log( wanted );
  $('.toprint').empty().html( to_print + ' Selected<span>' + to_print + ' Selected</span>' );

  return false;
});

$(document).on('click','.btn-mod-like',function(){
  let want = $(this).data('want');

  $(this).parent().toggleClass('selected');

  // console.log( 'clicked btn-mod-like ' + want );

  if( $.inArray( want, wanted ) >=  0 ){
    wanted = $.grep(wanted, function(value) {
      return value != want;
    });
  }else{
    wanted.push( want );
  }

  to_print = wanted.length;
  // console.log( wanted );
  $('.toprint').empty().html( to_print + ' Selected<span>' + to_print + ' Selected</span>' );

  return false;
});

$(document).on('click','.print-collect',function(){
  // window.location =
  if( wanted.length ){
    // console.log( $(this).data('url') + '?handles=' +  wanted.join(',') );
    window.location = $(this).data('url') + '?handles=' +  wanted.join(',');
  }
  return false;
});

function selectWanted(){
  let target = collections;

  if( sec_collect.length )
    target = sec_collect;

  let wantedCollect = sessionStorage.getItem('wantedCollect');
  if( wantedCollect ){
    wanted_obj = JSON.parse(wantedCollect);
    wanted = JSON.parse(wantedCollect);
  }else{
    wanted_obj = wanted;
  }

  target.find('.item-collect').each(function(){
    let handle = $(this).attr('data-want');
    if( $.inArray( handle, wanted_obj ) >= 0 ){
      // console.log( 'handle ------------------------------------- ' + handle );
      // console.log( wanted );
      $(this).addClass('selected');
    }
  });
}

let jsonCollect = [];
let activeColObj = [];
let pagingSet = 1;
let visibleColItems = 0;
let collect_page = 1;
const collections_json_url = '//mgae.dev1.p80w.com/collections-kids.json';

$(document).on('click','.paging-collect a',function(){
  let total_page = $('.paging-collect a').length
    index_page = $(this).index() + 1;

  $(this).siblings().removeClass('visible active');
  $(this).addClass('visible').addClass('active');

  // console.log( $(this).index() + ' -- ' + total_page );

  $('.collections > div').removeClass('active').hide();
  $('.collections').find( $( $(this).data('page') ) ).addClass('active');

  if( index_page > 2 && index_page <= ( total_page - 2 ) ){
    $(this).prev().addClass('visible');
    $(this).prev().prev().addClass('visible');
    $(this).next().addClass('visible');
    $(this).next().next().addClass('visible');
  }else if( index_page == 1 ){
    $(this).next().addClass('visible');
    $(this).next().next().addClass('visible');
    $(this).next().next().next().addClass('visible');
    $(this).next().next().next().next().addClass('visible');
  }else if( index_page == 2 ){
    $(this).prev().addClass('visible');
    $(this).next().addClass('visible');
    $(this).next().next().addClass('visible');
    $(this).next().next().next().addClass('visible');
  }else if( index_page == ( total_page - 1 ) ){
    $(this).prev().addClass('visible');
    $(this).prev().prev().addClass('visible');
    $(this).prev().prev().prev().addClass('visible');
    $(this).prev().prev().prev().prev().addClass('visible');
  }else if( index_page == ( total_page - 2 ) ){
    $(this).next().addClass('visible');
    $(this).prev().addClass('visible');
    $(this).prev().prev().addClass('visible');
    $(this).prev().prev().prev().addClass('visible');
  }

  $('html, body').animate({
    scrollTop: $('.contents').offset().top
  },600);
  return false;
});

if( $('.sec-collect-list').length ){
  pull_json_collections_grid(collect_page);
}

function pull_json_collections_grid(current_page){
  // var localjsonCollect = localStorage.getItem("jsonCollect");
  var localjsonCollect = getWithExpiry("jsonCollect");
  if( localjsonCollect ){
    // console.log( 'stored being loaded....' );
    console.log( localjsonCollect );
    // jsonCollect = JSON.parse(localjsonCollect);
    jsonCollect = localjsonCollect;
    activeColObj = jsonCollect;
    $('.contents').removeClass('loading');
    buildColGrid(0,jsonCollect.length);
  }else{
    // console.log( 'new collect being loaded....' );
    $.ajax({url: collections_json_url, success: function(result){
      jsonCollect = $.parseJSON(JSON.stringify(result));
      // console.log( jsonCollect );
      activeColObj = jsonCollect;
      collect_page++;

      $('.contents').removeClass('loading');
      // localStorage.setItem('jsonCollect', JSON.stringify(jsonCollect));
      setWithExpiry('jsonCollect', jsonCollect, 290000);
      // console.log('all done........... ' + jsonCollect.length );
      buildColGrid(75,jsonCollect.length);
    }});
  }
}

function setWithExpiry(key, value, ttl) {
  const now = new Date()

  // `item` is an object which contains the original value
  // as well as the time when it's supposed to expire
  const item = {
    value: value,
    expiry: now.getTime() + ttl,
  }
  localStorage.setItem(key, JSON.stringify(item))
}

function getWithExpiry(key) {
  const itemStr = localStorage.getItem(key)

  // if the item doesn't exist, return null
  if (!itemStr) {
    return null
  }

  const item = JSON.parse(itemStr)
  const now = new Date()

  // compare the expiry time of the item with the current time
  if (now.getTime() > item.expiry) {
    // If the item is expired, delete the item from storage
    // and return null
    localStorage.removeItem(key)
    return null
  }
  return item.value
}

function buildColGrid(start = 0,end = 74){ // 75 items or 5 pages
  let page_item = [];
  let items_collect = activeColObj;
  let total_items = items_collect.length - 1;
  let active_page = '';

  visibleColItems = 0; // reset counter
  // pagingSet = 1;
  // console.log( 'pagingSet -------- ' + pagingSet );

  for( var counter = start; counter <= end; counter++ ){
    if( items_collect[counter] ){
      let odd_even = '';

      if( ( counter % 2 ) == 1 )
        odd_even = 'even';
      else
        odd_even = 'odd';

      let template = `
      <div class="item item-collect `+ odd_even +`" data-want="`+ items_collect[counter].handle +`">
          <div class="text">
              <span class="name">`+ items_collect[counter].title +`</span>
              <span class="number">`+ items_collect[counter].desc +`</span>
              <span class="quote">`+ items_collect[counter].quote +`</span>
              <span class="club">`+ items_collect[counter].attr_club +`</span>
              <span class="rarity">`+ items_collect[counter].attr_rarity +`</span>
              <span class="series">`+ items_collect[counter].attr_series +`</span>
          </div>
          <figure><img class="lazyload"  data-src="`+ items_collect[counter].thumb +`" data-widths="[200, 360, 540, 720, 900, 1080, 1296, 1512, 1728, 2048]" data-aspectratio="1.0" data-sizes="auto" alt=""></figure>
          <a href="#" class="btn-like"><svg width="26" height="24" viewBox="0 0 26 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M12.9994 24C12.5981 23.9997 12.2061 23.8786 11.8745 23.6525C6.96252 20.3179 4.83524 18.0281 3.66287 16.602C1.16312 13.5561 -0.0342512 10.4277 0.000745158 7.04052C0.0394911 3.15842 3.15292 0 6.94127 0C9.49101 0 11.3158 1.32861 12.4532 2.55098C12.5233 2.62512 12.6078 2.68418 12.7015 2.72454C12.7952 2.7649 12.8961 2.78572 12.9981 2.78572C13.1002 2.78572 13.2011 2.7649 13.2948 2.72454C13.3885 2.68418 13.473 2.62512 13.5431 2.55098C14.6817 1.32861 16.5053 0 19.055 0C22.8434 0 25.9568 3.15842 25.9955 7.04052C26.0305 10.4277 24.8319 13.5561 22.3334 16.602C21.161 18.0319 19.0338 20.3179 14.1218 23.6525C13.7909 23.8781 13.3999 23.9992 12.9994 24Z" fill="white"/></svg></a>
          <span class="circle"></span>
          <a href="#" class="collect-modal" title="`+ items_collect[counter].title +`"></a>
      </div>
      `;

      // console.log( items_collect[counter].title );
      page_item.push( template );
      visibleColItems ++;

      if( page_item.length > 0 && ( ( counter % 15 ) == 14 || counter == total_items ) ){
        if( pagingSet == 1 )
          active_page = ' active';
        else
          active_page = '';

        let item_code = $('<div class="col-page col-page-'+ pagingSet + active_page +'"></div>').html( page_item.join('') );
        collections.append( item_code );
        $('.paging-collect').append( '<a href="#" data-page=".col-page-' + pagingSet + '" class="' + active_page + '">' + pagingSet + '</a>' );
        page_item = [];
        pagingSet++;
      }
    }else{
      $('.paging-collect').addClass('loaded');
      $('.paging-collect .active').next().addClass('visible');
      $('.paging-collect .active').next().next().addClass('visible');
      $('.paging-collect .active').next().next().next().addClass('visible');
      $('.paging-collect .active').next().next().next().next().addClass('visible');

      $('.contents').removeClass('loading');

      setTimeout(selectWanted,200);
      break;
    }
  }

  setTimeout(function(){
    $('.contents').removeClass('loading');
    selectWanted();
  },200);
}

function pull_json_collections(current_page){
  let start = ( current_page > 1 ) ? ( parseInt( current_page ) - 1 ) * 48 : 0;
  let end = ( current_page > 1 ) ? ( parseInt( current_page ) * 48 ) - 1 : 47;

  // console.log( 'current_page: ' + current_page +  ' -- start: ' + start + ' -- end: ' + end );

  // var localjsonCollect = localStorage.getItem("jsonCollect");
  var localjsonCollect = getWithExpiry("jsonCollect");
  if( activeColObj.length ){
    // console.log('all filter........... ' + activeColObj.length );
    buildColSlider(start,end);
  }else if( localjsonCollect ){
    jsonCollect = localjsonCollect;
    activeColObj = jsonCollect;
    // collect_page++;
    // console.log('all stored........... ' + activeColObj.length );
    buildColSlider(start,end);
  }else{
    // console.log( 'new collect being loaded....' );
    $.ajax({url: collections_json_url, success: function(result){
      jsonCollect = $.parseJSON(JSON.stringify(result));
      activeColObj = jsonCollect;
    }}).done(function(){
      // console.log( 'done activeColObj: ' );
      // console.log( activeColObj );
      // collect_page++;
      // localStorage.setItem('jsonCollect', JSON.stringify(jsonCollect));
      setWithExpiry('jsonCollect', jsonCollect, 290000);
      // console.log('all new........... ' + activeColObj.length );
      buildColSlider(start,end);
    });
  }
}

function buildColSlider(start = 0,end = 47){ // 48 items or 6 slides
  let slide_item = [];
  let items_collect = activeColObj;
  let total_items = items_collect.length - 1;

  // console.log( 'init buildColSlider -- ' + start + ' --- ' + end );
  // console.log( 'items_collect' );
  // console.log( items_collect );

  visibleColItems = 0; // reset counter
  pagingSet ++;

  for( var counter = start; counter <= end; counter++ ){
    if( items_collect[counter] ){
      let odd_even = '';

      // console.log( items_collect[counter].title );

      if( ( counter % 2 ) == 1 )
        odd_even = 'even';
      else
        odd_even = 'odd';

      let template = `
      <div class="item item-collect `+ odd_even +`" data-want="`+ items_collect[counter].handle +`"">
          <div class="text">
              <span class="name">`+ items_collect[counter].title +`</span>
              <span class="number">`+ items_collect[counter].desc +`</span>
              <span class="quote">`+ items_collect[counter].quote +`</span>
              <span class="club">`+ items_collect[counter].attr_club +`</span>
              <span class="rarity">`+ items_collect[counter].attr_rarity +`</span>
              <span class="series">`+ items_collect[counter].attr_series +`</span>
          </div>
          <figure><img class="lazyload"  data-src="`+ items_collect[counter].thumb +`" data-widths="[200, 360, 540, 720, 900, 1080, 1296, 1512, 1728, 2048]" data-aspectratio="1.0" data-sizes="auto" alt=""></figure>
          <a href="#" class="btn-like"><svg width="26" height="24" viewBox="0 0 26 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M12.9994 24C12.5981 23.9997 12.2061 23.8786 11.8745 23.6525C6.96252 20.3179 4.83524 18.0281 3.66287 16.602C1.16312 13.5561 -0.0342512 10.4277 0.000745158 7.04052C0.0394911 3.15842 3.15292 0 6.94127 0C9.49101 0 11.3158 1.32861 12.4532 2.55098C12.5233 2.62512 12.6078 2.68418 12.7015 2.72454C12.7952 2.7649 12.8961 2.78572 12.9981 2.78572C13.1002 2.78572 13.2011 2.7649 13.2948 2.72454C13.3885 2.68418 13.473 2.62512 13.5431 2.55098C14.6817 1.32861 16.5053 0 19.055 0C22.8434 0 25.9568 3.15842 25.9955 7.04052C26.0305 10.4277 24.8319 13.5561 22.3334 16.602C21.161 18.0319 19.0338 20.3179 14.1218 23.6525C13.7909 23.8781 13.3999 23.9992 12.9994 24Z" fill="white"/></svg></a>
          <span class="circle"></span>
          <a href="#" class="collect-modal" title="`+ items_collect[counter].title +`"></a>
      </div>
      `;

      if( $(window).width() > 1200 ){
        slide_item.push( template );
        visibleColItems ++;

        if( slide_item.length > 0 && ( ( counter % 8 ) == 7 || counter == total_items ) ){
          let item_code = $('<div class="slide-item"></div>').html( '<div>'+slide_item.join('')+'</div>' );
          kids_collect_slider.slick('slickAdd', item_code );
          slide_item = [];
        }
      }else{
        // console.log( items_collect[counter].title );
        kids_collect_slider_mobile.slick('slickAdd', $('<div class="slide-item slide-item-mob"></div>').html( '<div>'+template+'</div>' ) );
      }
    }else{
      setTimeout(selectWanted,200);
      break;
    }
  }

    sec_collect.find('.sec-heading').addClass('loaded');

    // console.log( activeColObj );
    collect_page++;

    // $( document ).trigger( "pullingDone", [ 'kids-collect' ] );

    if( $(window).width() > 1200 )
      formatDots( kids_collect_slider );
    else
      formatDots( kids_collect_slider_mobile );

  setTimeout(selectWanted,200);
}

function mergeSF(){ // merge search and filter
  let keyword = null, club = null, rarity = null, series = null, type = null;
  let filter_box = $('.filtered-tags');
  let filter_tags = [];

  $('.collect-widget li input:checked').each(function(){
    var thisVal = $(this).val();
    if( thisVal.indexOf( 'club-' ) >= 0 ){
      club = thisVal;
      filter_tags.push( '<span data-tag="'+ thisVal +'">'+ $(this).next().text() +'</span>' );
    }

    if( thisVal.indexOf( 'rarity-' ) >= 0 ){
      rarity = thisVal;
      filter_tags.push( '<span data-tag="'+ thisVal +'">'+ $(this).next().text() +'</span>' );
    }

    if( thisVal.indexOf( 'series-' ) >= 0 ){
      series = thisVal;
      filter_tags.push( '<span data-tag="'+ thisVal +'">'+ $(this).next().text() +'</span>' );
    }

    if( thisVal.indexOf( 'type-' ) >= 0 ){
      type = thisVal;
      filter_tags.push( '<span data-tag="'+ thisVal +'">'+ $(this).next().text() +'</span>' );
    }
  });

  if( filter_tags.length ){
    filter_box.find('div').empty().html( filter_tags.join('') );
    filter_box.addClass('active');
  }else{
    filter_box.removeClass('active');
  }

  keyword = $('#collect-search input').val().trim().toLowerCase();

  if( keyword == '' ){
    keyword = null;
  }

  // console.log( keyword + ' --- ' + club + ' --- ' + rarity + ' --- ' + series + ' --- ' + type );
  sfCollect( keyword, club, rarity, series, type );

  visibleColItems = 0; // reset counter
  pagingSet = 1; // reset pagingSet
}

$(document).on('click','.filtered-tags span',function(){
  let filter_tag = $(this).data('tag');
  // $('.collect-widget input[value="'+ filter_tag +'"]').prop('checked',false);
  $('.collect-widget input[value="'+ filter_tag +'"]').parent().next('.untick').trigger('click');
  setTimeout(mergeSF,400);
});

$('#collect-search').on('submit',function(){
  mergeSF();
  // console.log( 'trigger keyword ' );

  return false;
});

var timer = null;
$('#search-collect').keydown(function(){
       clearTimeout(timer);
       timer = setTimeout(triggerCollectSearch, 1000)
});

function triggerCollectSearch() {
  console.log( 'trigger search' );
  mergeSF();
}

$('.go-filter').on('click',function(){
  mergeSF();
  // console.log( 'trigger go filter ' );

  row_filters.hide();
  sec_collect.removeAttr('style');

  if( sec_collect.length ){
    $('html, body').animate({
      scrollTop: sec_collect.offset().top
    },600);
  }
  return false;
});

$('.collect-widget li input').on('click',function(){
  // console.log('run mergeSF.......');
  $(this).parents('ul').find('.untick').remove();
  $(this).parents('label').after('<span class="untick"></span>');

  if( sec_collect.length ){ // if kids home
    // do nothing
  }else{ // if collect archive
    $('.contents').addClass('loading');

    if( $('.sec-collect-list').length )
      $('html, body').animate({
        scrollTop: $('.sec-collect-list').offset().top
      },600);

    if( $(window).width() < 500 )
      $('aside').removeClass('on-mobile');

    setTimeout(mergeSF,200);
  }

  // console.log('tick filter');
});

$(document).on('click','.collect-widget .untick',function(){
  $(this).prev('label').children('input').prop('checked', false);
  $(this).remove();

  if( sec_collect.length ){ // if kids home
    // do nothing
  }else{ // if collect archive
    setTimeout(mergeSF,200);
  }
  // console.log('untick filter');
});

$('.reset-filter').on('click',function(){
  $('.collect-widget input').prop('checked', false);
  $('.heading-filter .input input').val('');
  no_results.removeClass('visible');

  visibleColItems = 0; // reset counter
  pagingSet = 0; // reset pagingSet
  activeColObj = jsonCollect; // restore back the original json obj

  buildColSlider();

  return false;
});

function sfCollect(keyword = null, club = null, rarity = null, series = null, type = null){ // search & filter collect

  // console.log('sfCollect......');

  activeColObj = $.grep(jsonCollect, function (e) {
    return ( keyword === '' || keyword === null || e.keyword.indexOf( keyword ) >= 0 ) &&
    ( club === '' || club === null || e.club == club )   &&
    ( rarity === '' || rarity === null || e.rarity == rarity )   &&
    ( series === '' || series === null || e.series == series )   &&
    ( type === '' || type === null || e.type == type );
  });

  if( activeColObj.length > 0 ){
    // console.log( 'not empty ' + activeColObj.length );
    // console.log( activeColObj );

    visibleColItems = 0; // reset counter
    pagingSet = 0; // reset paging count
    no_results.removeClass('visible');

    if( sec_collect.length ){ // if kids home
      // emptying slides
      if( $(window).width() > 1200 ){
        $('.kids-collect-slider').slick('slickRemove', null, null, true);
      }else{
        $('.kids-collect-slider-mobile').slick('slickRemove', null, null, true);
      }

      collect_page = 1;

      setTimeout(buildColSlider,200);
    }else{
      // console.log( 'call buildColGrid ' + activeColObj.length );
      collections.empty(); // empty collections container and load filtered items
      $('.paging-collect').empty(); // empty pagination

      setTimeout(function(){
        buildColGrid(0,activeColObj.length);
      },200);
    }

  }else{
    let container = sec_collect.length ? sec_collect : $('.sec-collect-list');

    no_results.addClass('visible');

    if( $('.contents').length )
      $('.contents').removeClass('loading');

    collect_page = 1;

    $('html, body').animate({
      scrollTop: container.offset().top
    },600);
  }
}

$('.toggle-filter').on('click',function(){
  // let sec_collect = $('.sec-collect');
  if( sec_collect.length ){ // if in kids home
    row_filters.fadeIn('fast');
    if( ( row_filters.children('div').outerHeight() + 250 ) >= sec_collect.outerHeight() ){
      sec_collect.css('minHeight', ( row_filters.children('div').outerHeight() + 250 ) + 'px' );
    }
  }else{
      $('aside').toggleClass('on-mobile');
      if( ( $('.on-mobile').outerHeight() + 200 ) >= $('.contents').outerHeight() ){
        $('.contents').css('minHeight', ( $('.on-mobile').outerHeight() + 200 ) + 'px' );
      }else{
        $('.on-mobile').css('minHeight', $('.contents').outerHeight() + 'px' );
      }
  }
  return false;
});

$(document).mouseup(function(e){
    var outside = $('.outside');
    if (!outside.is(e.target) && outside.has(e.target).length === 0){
      // row_filters.hide();
      // console.log('clicked inside');
    }else{
      row_filters.hide();
      sec_collect.removeAttr('style');
    }
});

$(document).on('click','.collect-modal',function(){
  let modal_collect = $('.modal-collect');
  let item = $(this).parents('.item');
  let attr = [];
  let thumb = "";

  modal_collect.removeClass('selected');
  modal_collect.find('.btn-mod-like').remove();

  // console.log( 'wanted --- ' + item.data('want') );

  if( $.inArray( item.data('want'), wanted ) >= 0 ){
    modal_collect.addClass('wanted');
  }

  if( item.find('figure').length )
    thumb = '<figure><img src="' + item.find('img').attr('src') + '" alt=""></figure>';

  if( item.find('.club').length )
    attr.push( '<li class="club"><span>Club:</span> '+ item.find('.club').text().trim() +'</li>' );

  if( item.find('.rarity').length )
    attr.push( '<li class="rarity"><span>Rarity:</span> '+ item.find('.rarity').text().trim() +'</li>' );

  if( item.find('.series').length )
    attr.push( '<li class="series"><span>Series:</span> '+ item.find('.series').text().trim() +'</li>' );

  let collect_data = thumb + `<div class="text">
        <h5>` + item.find('.name').text().trim() + `</h5>
        <p>&ldquo;` + item.find('.quote').text().trim() + `&rdquo;</p>
        <ul class="list-unstyled">
            <li class="character_number"><span class="ng-binding">Character #:</span> `+ item.find('.number').text().trim() +`</li>
            `+ attr.join('') +`
        </ul>
    </div>`;

  if( sec_collect.length ){
    sec_collect.addClass('active-modal');
  }else{
    $('.sec-collect-list .contents').addClass('active-modal');
    setTimeout(function(){
      $('html, body').animate({
        scrollTop: modal_collect.offset().top - 100
      },600);
    },200);
  }

  modal_collect.find('div').empty().append( collect_data );
  modal_collect.append( '<a href="#" class="btn-mod-like" data-want="' + item.data('want') + '"><svg width="26" height="24" viewBox="0 0 26 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M12.9994 24C12.5981 23.9997 12.2061 23.8786 11.8745 23.6525C6.96252 20.3179 4.83524 18.0281 3.66287 16.602C1.16312 13.5561 -0.0342512 10.4277 0.000745158 7.04052C0.0394911 3.15842 3.15292 0 6.94127 0C9.49101 0 11.3158 1.32861 12.4532 2.55098C12.5233 2.62512 12.6078 2.68418 12.7015 2.72454C12.7952 2.7649 12.8961 2.78572 12.9981 2.78572C13.1002 2.78572 13.2011 2.7649 13.2948 2.72454C13.3885 2.68418 13.473 2.62512 13.5431 2.55098C14.6817 1.32861 16.5053 0 19.055 0C22.8434 0 25.9568 3.15842 25.9955 7.04052C26.0305 10.4277 24.8319 13.5561 22.3334 16.602C21.161 18.0319 19.0338 20.3179 14.1218 23.6525C13.7909 23.8781 13.3999 23.9992 12.9994 24Z" fill="white"/></svg></a>' );
  modal_collect.fadeIn('fast');
  return false;
});

$(document).on('click','.close-modal-collect',function(){
  let modal_collect = $('.modal-collect');

  if( sec_collect.length ){
    sec_collect.removeClass('active-modal');
  }else{
    $('.sec-collect-list .contents').removeClass('active-modal');
  }

  modal_collect.hide();

  selectWanted();

  return false;
});








function compareResults(a, b) {
  const bandA = a.score;
  const bandB = b.score;

  let comparison = 0;
  if (bandA > bandB) {
    comparison = 1;
  } else if (bandA < bandB) {
    comparison = -1;
  }
  return comparison * -1;
}

function changeScore( name, score ) {
  for (var i in results) {
    if (results[i].name == name) {
       results[i].score = score;
       break; //Stop this loop, we found it!
    }
  }
}

$(document).on('click','.choices .item:not(.selected)',function(){
  var $this = $(this);
  $this.siblings().removeClass('selected');
  $this.addClass('selected');
  $this.parents('.qa').attr('data-qa',$this.data('opts'));
  // console.log( 'selected ------------- ' + $this.data('opts') );

  if( $this.parents('.qa').next('.qa').length ){
    $('html, body').animate({
      scrollTop: $this.parents('.qa').next('.qa').offset().top - 100
    },600);
  }else{
    let result = $('.sec-quiz-result');
    $('.qa').each(function(){
      if( $(this).attr('data-qa').length ){
        let i;
        let choices = $(this).attr('data-qa').split(',');
        for (i = 0; i < choices.length; i++) {
          if( choices[i].includes(':') ){
            let choice = choices[i].split(':');
            let key = choice[0];
            let score = parseInt( choice[1] );
            let current = results.find(o => o.name === key);
            // console.log( 'key ' + key );
            // console.log( 'old score ' + score );
            // console.log( 'current score ' + current.score );
            changeScore( key, ( score + current.score ) );
          }
        }
      }
    });

    results.sort(compareResults);
    // console.log( results );
    // console.log( results[0].name );
    $('.sec-quiz-qas').addClass('quiz-done');

    result.find('.card').empty().append('<img src="'+ results[0].image +'"/>');
    result.find('.download-img').attr('href',results[0].image + '&format=png');

    $('html, body').animate({
      scrollTop: $('.sec-quiz-result').offset().top + 100
    },600);
  }
});

$('.restart-quiz').on('click',function(){
  let quiz_qas = $('.sec-quiz-qas');
  quiz_qas.find('.choices .item').removeClass('selected');

  for (i = 0; i < results.length; i++) {
    // console.log( results[i].name );
    changeScore( results[i].name, 0 );
  }

  // console.log( results );

  $('html, body').animate({
    scrollTop: quiz_qas.offset().top - 100
  },600,function(){
    quiz_qas.removeClass('quiz-done');
  });

  return false;
});

$('.download-img').on('click',function(){
  window.open( $(this).attr('href'), '_blank');
  return false;
});

let liked = [];

$(document).on('click','.heart',function(){
  let like_item = $(this).data('like');

  $(this).toggleClass('liked');

  if( $.inArray( like_item, liked ) >= 0 ){
    liked = $.grep(liked, function(value) {
      return value != like_item;
    });
  }else{
    liked.push( like_item );
  }

  // console.log( liked );

  sessionStorage.setItem('hearted', JSON.stringify(liked));

  return false;
});



function selectHearted(){

  let hearted = sessionStorage.getItem('hearted');
  if( hearted ){
    hearted_obj = JSON.parse(hearted);
    liked = JSON.parse(hearted);
  }else{
    hearted_obj = liked;
  }

  $('.kids-like-slider').find('.heart').each(function(){
    let handle = $(this).attr('data-like');
    if( $.inArray( handle, hearted_obj ) >= 0 ){
      // console.log( 'handle ------------------------------------- ' + handle );
      // console.log( wanted );
      $(this).addClass('liked');
    }
  });
}

if( $('.os-ios').length ){
  // console.log( $(window).width() );
  $('html').addClass('html-os-ios');
}

if( $('.sec-puzzle-game').length ){
  let game = $('.game');
  if( game.children('iframe').length ){
    game.append('<a href="#" data-tourl="'+ game.children('iframe').attr('src') +'"  target="_blank" rel="noopener noreferrer" class="puzzle-url"></a>');
  }
}
  // AGE GATE
  var ageDa, ageMo, ageYr, toURL, optionsLoaded = false;

  $(document).on('click','[data-tourl]',function(){
    toURL = $(this).data('tourl');
    $('body').toggleClass('age-active');
    $('.age-gate').toggleClass('open');
    // console.log( '$toURL ' + toURL );
    if( $('body').hasClass('door-active') ){
      $('body').removeClass('door-active');
    }

    // inject options only when needed to reduce dom
    if( ! optionsLoaded ){
      $('select[name="month"]').append( '<option value="01">January</option><option value="02">February</option><option value="03">March</option><option value="04">April</option><option value="05">May</option><option value="06">June</option><option value="07">July</option><option value="08">August</option><option value="09">September</option><option value="10">October</option><option value="11">November</option><option value="12">December</option>' );
      $('select[name="day"]').append( '<option value="01">1</option><option value="02">2</option><option value="03">3</option><option value="04">4</option><option value="05">5</option><option value="06">6</option><option value="07">7</option><option value="08">8</option><option value="09">9</option><option value="10">10</option><option value="11">11</option><option value="12">12</option><option value="13">13</option><option value="14">14</option><option value="15">15</option><option value="16">16</option><option value="17">17</option><option value="18">18</option><option value="19">19</option><option value="20">20</option><option value="21">21</option><option value="22">22</option><option value="23">23</option><option value="24">24</option><option value="25">25</option><option value="26">26</option><option value="27">27</option><option value="28">28</option><option value="29">29</option><option value="30">30</option><option value="31">31</option>' );
      $('select[name="year"]').append( '<option value="2017">2017</option><option value="2016">2016</option><option value="2015">2015</option><option value="2014">2014</option><option value="2013">2013</option><option value="2012">2012</option><option value="2011">2011</option><option value="2010">2010</option><option value="2009">2009</option><option value="2008">2008</option><option value="2007">2007</option><option value="2006">2006</option><option value="2005">2005</option><option value="2004">2004</option><option value="2003">2003</option><option value="2002">2002</option><option value="2001">2001</option><option value="2000">2000</option><option value="1999">1999</option><option value="1998">1998</option><option value="1997">1997</option><option value="1996">1996</option><option value="1995">1995</option><option value="1994">1994</option><option value="1993">1993</option><option value="1992">1992</option><option value="1991">1991</option><option value="1990">1990</option><option value="1989">1989</option><option value="1988">1988</option><option value="1987">1987</option><option value="1986">1986</option><option value="1985">1985</option><option value="1984">1984</option><option value="1983">1983</option><option value="1982">1982</option><option value="1981">1981</option><option value="1980">1980</option><option value="1979">1979</option><option value="1978">1978</option><option value="1977">1977</option><option value="1976">1976</option><option value="1975">1975</option><option value="1974">1974</option><option value="1973">1973</option><option value="1972">1972</option><option value="1971">1971</option><option value="1970">1970</option><option value="1969">1969</option><option value="1968">1968</option><option value="1967">1967</option><option value="1966">1966</option><option value="1965">1965</option><option value="1964">1964</option><option value="1963">1963</option><option value="1962">1962</option><option value="1961">1961</option><option value="1960">1960</option><option value="1959">1959</option><option value="1958">1958</option><option value="1957">1957</option><option value="1956">1956</option><option value="1955">1955</option><option value="1954">1954</option><option value="1953">1953</option><option value="1952">1952</option><option value="1951">1951</option><option value="1950">1950</option><option value="1949">1949</option><option value="1948">1948</option><option value="1947">1947</option><option value="1946">1946</option><option value="1945">1945</option><option value="1944">1944</option><option value="1943">1943</option><option value="1942">1942</option><option value="1941">1941</option><option value="1940">1940</option><option value="1939">1939</option><option value="1938">1938</option><option value="1937">1937</option>' );
      optionsLoaded = true;
    }

    return false;
  });

  $('.close-age-modal').on('click',function(){
    $('body').removeClass('age-active');
    $('.age-gate').removeClass('open');
    return false;
  });

  $('.dropdown-select select').on('change',function(){
    let select = $(this),
        type = select.attr('name');

    if( type == 'day' ){
      ageDa = select.val();
    }else if( type == 'month' ){
      ageMo = select.val();
    }else if( type == 'year' ){
      ageYr = select.val();
    }
  });

    $('.redirect').on('click',function(){
        window.open( toURL );
        $('body').removeClass('age-active');
        $('.age-gate').removeClass('open');;});

  $('.cont-redirect').on('click',function(){
    $('.valid-date').hide();
    if( ageYr != undefined &&  ageMo != undefined &&  ageDa != undefined ){
      var dateString = ageYr + '/' + ageMo + '/' + ageDa;

      // console.log( 'dateString ' + dateString );

      var today = new Date();
      var birthDate = new Date(dateString);
      var age = today.getFullYear() - birthDate.getFullYear();
      var m = today.getMonth() - birthDate.getMonth();
      if (m < 0 || (m === 0 && today.getDate() < birthDate.getDate())) {
          age--;
      }

      if( age >= 12 ){
        // console.log( 'age redirect now' );
        window.open( toURL );
        $('body').removeClass('age-active');
        $('.age-gate').removeClass('open');
      }else{
        $('.underage').addClass('active');
      }
    }else{
      $('.valid-date').show();
    }

    setCookie('splash_loaded','yes');
    return false;
  });

  let playLoaded    = false;
      watchLoaded   = false,
      quizLoaded    = false,
      collectLoaded = false,
      omgLoaded     = false,
      printLoaded   = false,
      likeLoaded    = false,
      appsLoaded    = false,
      hotLoaded     = false;

  let isHome = false;
  let isVideos = false;
  if( $('.template-index').length ){
    isHome = true;
  }else if( $('.template-blog-videos').length ){
    isVideos = true;
  }

  $(window).on('resize scroll', function() {
    // $.debounce(50, function() {
      if( isHome ){
        if( $('.sec-play').isInViewport() && ! playLoaded ){
          start_play();
          start_puzzles();
          playLoaded = true;
        }else if( $('.sec-watch').isInViewport() && ! watchLoaded ){
          start_watch_all();
          watchLoaded = true;
        // }else if( $('.sec-quizzes').isInViewport() && ! quizLoaded ){
        //   start_quizzes();
        //   quizLoaded = true;
        }else if( $('.sec-collect').isInViewport() && ! collectLoaded ){
          start_collect();
          collectLoaded = true;
        // }
        // else if( $('.sec-hot').isInViewport() && ! hotLoaded ){
        //   start_products();
        //   hotLoaded = true;
        }else if( $('.sec-omg').isInViewport() && ! omgLoaded ){
          start_omg();
          omgLoaded = true;
        }else if( $('.sec-print').isInViewport() && ! printLoaded ){
          start_print();
          printLoaded = true;
        // }else if( $('.sec-like').isInViewport() && ! likeLoaded ){
        //   start_like();
        //   likeLoaded = true;
        // }else if( $('.sec-apps').isInViewport() && ! appsLoaded ){
        //   start_apps();
        //   appsLoaded = true;
        }
      }else if( isVideos ){
        if( $('.sec-watch').isInViewport() && ! watchLoaded ){
          console.log( 'trigger watch..' );
          start_watch_commercials();
          watchLoaded = true;
        }
      }
    // });
  });


  $(document).on('pullingDone',function( event, nextPull){
    // console.log( 'nextPull ' + nextPull );
    if( nextPull == 'kids-play' ){
      pull_play(play_page);
    }else if( nextPull == 'kids-puzzle' ){
      pull_puzzles(puzzle_page);
    }else if( nextPull == 'watch-all' ||  nextPull == 'watch-all-mob' ){
      pull_allWatch(watch_page);
    }else if( nextPull == 'watch-commercials' || nextPull == 'watch-commercials-mob' ){
      pull_commercials(commercials_page);
    }else if( nextPull == 'watch-demos' || nextPull == 'watch-demos-mob' ){
      pull_demos(demos_page);
    }else if( nextPull == 'watch-makeovers' || nextPull == 'watch-makeovers-mob' ){
      pull_makeovers(makeover_page);
    }else if( nextPull == 'watch-omg' || nextPull == 'watch-omg-mob' ){
      pull_omgs(omgs_page);
    }else if( nextPull == 'watch-playsodes' || nextPull == 'watch-playsodes-mob' ){
      pull_playsodes(playsodes_page);
    }else if( nextPull == 'watch-unboxed' || nextPull == 'watch-unboxed-mob' ){
      pull_unboxed(unboxed_page);
    }else if( nextPull == 'kids-quiz' ){
      pull_quiz(quiz_page);
    }else if( nextPull == 'kids-omg' ){
      pull_omg(omg_page);
    }else if( nextPull == 'kids-hot' ){
      pull_products(products_page);
    }else if( nextPull == 'kids-collect' ){
      pull_json_collections(collect_page);
      // console.log( 'triggered kids collect' );
      // collect_slider_afterChange();
    }
  });

  // footer brand logos
  if($('#footerBrandsMobileContainer').length && $('#footerBrandLogos').length ) {
    $('#footerBrandLogos').clone().appendTo('#footerBrandsMobileContainer');
  }

  //VIEW ALL cta link in footer brand logos
  $('.js-toggle-item').on('click', function(){
    $('#footerBrandLogos .logo-bar__item').removeClass("hide");
    $(this).parent().hide();
  });

  $('.js-expand-collapse').on('click', function(e){
    var $parent = $(this).parent();
    var $this = $(this);
    var $target = $parent.next('.js-expand-collapse__content');

    $('.js-expand-collapse').removeClass('active');

    if ($target.hasClass('active')) {
        $target.removeClass('active');
        $target.slideUp(300);
    } else {
        $('.js-expand-collapse__content').slideUp(300);
        $('.js-expand-collapse__content').removeClass('active');
        $this.addClass('active');
        $target.addClass('active');
        $target.slideToggle(300);
    }
  });

  /*============================================================================
  Privacy Bar
  ==============================================================================*/
  var privacy_status = getCookie('privacy_cookie_accepted');
  console.log('loaded.... ' + privacy_status);
  if(privacy_status == 'yes') {
    $('#privacyBar').css('display','none');
  }else {
    $('#privacyBar').css('display','block');
  }

  $('.js-privacy-btn' ).on('click', function(e) {
    setCookieExp('privacy_cookie_accepted','yes', 7);
    $('#privacyBar').hide();
  });

});

$.fn.isInViewport = function() {
  if ($(this).length == 0) return 
  let elementTop = $(this).offset().top;
  let elementBottom = elementTop + $(this).outerHeight();
  let viewportTop = $(window).scrollTop() + 100;
  let viewportBottom = viewportTop + $(window).height();
  return elementBottom > viewportTop && elementTop < viewportBottom;
};

// function setCookie(cname, cvalue) {
// 	var d = new Date();
// 	/*d.setTime(d.getTime() + (exdays*24*60*60*1000));*/
// 	var expires = "expires="+ d.toUTCString();
// 	document.cookie = cname + "=" + cvalue + ";path=/";
// }
// setCookie('splash_loaded','no');



function getCookie(cname) {
	var name = cname + "=";
	var decodedCookie = decodeURIComponent(document.cookie);
	var ca = decodedCookie.split(';');
	for(var i = 0; i <ca.length; i++) {
		var c = ca[i];
		while (c.charAt(0) == ' ') {
			c = c.substring(1);
		}
		if (c.indexOf(name) == 0) {
			return c.substring(name.length, c.length);
		}
	}
	return "";
}

function setCookie(cname, cvalue) {
	var d = new Date();
	/*d.setTime(d.getTime() + (exdays*24*60*60*1000));*/
	var expires = "expires="+ d.toUTCString();
	document.cookie = cname + "=" + cvalue + ";path=/";
}

function setCookieExp(cname, cvalue, exdays) {
	var d = new Date();
	d.setTime(d.getTime() + (exdays*24*60*60*1000));
	var expires = "expires="+ d.toUTCString();
	document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
}
